import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import { ArrowBack, Close } from '@magalu/stereo-ui-icons';
import { string, func, oneOf, shape, oneOfType, number, bool } from 'prop-types';
import { Container, Title, LeftButton } from './sidebar-header.styles';
const Icons = {
  close: Close,
  back: ArrowBack
};

const SidebarHeader = _ref => {
  let {
    label,
    align,
    fontSize,
    leftButton,
    showCloseButton
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["label", "align", "fontSize", "leftButton", "showCloseButton"]);

  const {
    icon,
    title,
    onClick,
    iconColor = '#8c8c8c'
  } = leftButton;
  const LeftIcon = Icons[icon || 'close'];
  return /*#__PURE__*/React.createElement(Container, _extends({}, props, {
    align: align,
    "data-testid": "sidebar-header"
  }), /*#__PURE__*/React.createElement(LeftButton, null, showCloseButton && /*#__PURE__*/React.createElement(LeftIcon, {
    color: iconColor,
    role: "button",
    title: title,
    "data-testid": `${icon}-button`,
    onClick: onClick
  })), /*#__PURE__*/React.createElement(Title, _extends({
    fontSize: fontSize
  }, props, {
    "data-testid": "title"
  }), label));
};

process.env.NODE_ENV !== "production" ? SidebarHeader.propTypes = {
  label: string,
  align: oneOf(['left', 'center', 'right']),
  fontSize: oneOfType([string, number]),
  leftButton: shape({
    icon: oneOf(['close', 'back']),
    title: string,
    onClick: func
  }),
  showCloseButton: bool
} : void 0;
SidebarHeader.defaultProps = {
  align: 'center',
  fontSize: 1,
  leftButton: {
    icon: 'close',
    onClick: () => {}
  },
  showCloseButton: true
};
export default SidebarHeader;